import { BundlePriceTypeEnum } from '@cdaas/api-clients/dist/product-service-openapi';

export const bundlePriceTypesInUse = Object.entries(BundlePriceTypeEnum).filter(
  ([key, value]) =>
    value === BundlePriceTypeEnum.Monthly12 ||
    value === BundlePriceTypeEnum.Monthly24 ||
    value === BundlePriceTypeEnum.Monthly30 ||
    value === BundlePriceTypeEnum.Monthly36,
);
